import moment from 'moment';

export default  ({ month, year }) => moment(`${year}-${month}-01`, 'YYYY-M-DD');
